module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("tKwiv"))).then(() => parcelRequire('2KbAe'));